import { getAuth, onAuthStateChanged } from "firebase/auth";

export function authStateReady() {
  return new Promise((resolve) => {
    const auth = getAuth();

    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
}

export async function getCurrentUserId() {
  const user = await authStateReady();

  if (!user) {
    throw new Error("Пользователь не авторизован");
  }

  return user.uid;
}